import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function CreativeDirection() {
  const projects = [{
    title: 'BioMaxing',
    category: 'Biohacking Platform',
    description: 'Co-founded startup directing the brand identity, UX/UI design and marketing strategy for a multi-platform biohacking and wellness application',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/csnG4bVtScAfPFwFpCSryS/image.png',
    color: 'from-cyan-100 to-teal-100',
    link: '/projects/biomaxing'
  }, {
    title: 'Co-Lab',
    category: 'Wellness Marketplace',
    description: 'UX direction and creative strategy for an innovative beauty and wellness digital marketplace with immersive 3D experiences and gamified engagement',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8LTTFmnCvJNw4uDXDai346/image.png',
    color: 'from-cyan-100 to-stone-100',
    link: '/projects/co-lab'
  }, {
    title: 'Fizkultura',
    category: 'Fitness Studio',
    description: 'Studio planning and design, creative direction and brand strategy development for a fitness space focused on community building',
    image: 'https://storage.yandexcloud.net/maria-images/images/fizkultura_ready/fizra_preview.png',
    color: 'from-emerald-100 to-teal-100',
    link: '/projects/fizkultura'
  }];
  return <div className="w-full min-h-screen bg-stone-50" data-id="element-965">
      {/* Header */}
      <header className="py-8 px-6 bg-white border-b border-stone-200" data-id="element-966">
        <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-967">
          <Link to="/" className="inline-flex items-center gap-2 text-stone-600 hover:text-stone-900 transition-colors" data-id="element-968">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-969" />
            <span className="font-light" data-id="element-970">Back to Home</span>
          </Link>
          <h1 className="text-2xl font-light text-stone-900" data-id="element-971">Maria Elina</h1>
        </div>
      </header>
      {/* Hero Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-stone-50 via-emerald-50/30 to-stone-50" data-id="element-972">
        <div className="max-w-7xl mx-auto text-center" data-id="element-973">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-974">
            <div className="text-6xl mb-6" data-id="element-975">🌿</div>
            <h2 className="text-5xl md:text-7xl font-light text-stone-900 mb-6" data-id="element-976">
              Creative Direction
            </h2>
            <p className="text-xl text-stone-600 font-light max-w-2xl mx-auto" data-id="element-977">
              Strategic vision that brings harmonious multidisciplinary projects to life
            </p>
          </motion.div>
        </div>
      </section>
      {/* Projects Grid */}
      <section className="py-20 px-6" data-id="element-978">
        <div className="max-w-7xl mx-auto" data-id="element-979">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-980">
            {projects.map((project, index) => <motion.div key={project.title} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} whileHover={{
            y: -10
          }} className="group cursor-pointer" data-id="element-981">
                {project.link ? <Link to={project.link} data-id="element-982">
                    <div className="relative overflow-hidden rounded-2xl mb-6 aspect-[4/3]" data-id="element-983">
                      <motion.img src={project.image} alt={project.title} className="w-full h-full object-cover" whileHover={{
                  scale: 1.05
                }} transition={{
                  duration: 0.6
                }} data-id="element-984" />
                      <div className={`absolute inset-0 bg-gradient-to-br ${project.color} opacity-0 group-hover:opacity-40 transition-opacity duration-500`} data-id="element-985" />
                    </div>
                    <div className="space-y-2" data-id="element-986">
                      <p className="text-sm text-emerald-700 font-light tracking-wide uppercase" data-id="element-987">
                        {project.category}
                      </p>
                      <h3 className="text-2xl font-light text-stone-900 group-hover:text-emerald-800 transition-colors" data-id="element-988">
                        {project.title}
                      </h3>
                      <p className="text-stone-600 font-light leading-relaxed" data-id="element-989">
                        {project.description}
                      </p>
                    </div>
                  </Link> : <>
                    <div className="relative overflow-hidden rounded-2xl mb-6 aspect-[4/3]" data-id="element-990">
                      <motion.img src={project.image} alt={project.title} className="w-full h-full object-cover opacity-60" whileHover={{
                  scale: 1.05
                }} transition={{
                  duration: 0.6
                }} data-id="element-991" />
                      <div className={`absolute inset-0 bg-gradient-to-br ${project.color} opacity-40`} data-id="element-992" />
                    </div>
                    <div className="space-y-2" data-id="element-993">
                      <p className="text-sm text-emerald-700 font-light tracking-wide uppercase" data-id="element-994">
                        {project.category}
                      </p>
                      <h3 className="text-2xl font-light text-stone-900" data-id="element-995">
                        {project.title}
                      </h3>
                      <p className="text-stone-600 font-light leading-relaxed" data-id="element-996">
                        {project.description}
                      </p>
                    </div>
                  </>}
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-t from-emerald-50/40 via-stone-50 to-stone-50 border-t border-emerald-600/30" data-id="element-997">
        <div className="max-w-4xl mx-auto text-center" data-id="element-998">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-999">
            <h2 className="text-4xl md:text-5xl font-light mb-6 text-stone-900" data-id="element-1000">
              Interested in collaborating?
            </h2>
            <p className="text-xl text-stone-600 font-light mb-8" data-id="element-1001">
              Let's create something meaningful together
            </p>
            <motion.a href="mailto:rassvet.hub@gmail.com" whileHover={{
            y: -3
          }} className="group inline-block relative" data-id="element-1002">
              {/* Outer border layer */}
              <div className="absolute inset-0 border-2 border-emerald-600 pointer-events-none" style={{
              clipPath: 'polygon(5% 0%, 100% 0%, 95% 100%, 0% 100%)'
            }} data-id="element-1003" />
              {/* Inner filled layer */}
              <div className="relative px-6 py-2 bg-emerald-600 text-white overflow-hidden mx-3 my-1.5" style={{
              clipPath: 'polygon(8% 0%, 100% 0%, 92% 100%, 0% 100%)'
            }} data-id="element-1004">
                <div className="absolute inset-0 bg-emerald-700 translate-y-[100%] group-hover:translate-y-0 transition-transform duration-300" data-id="element-1005" />
                <span className="text-lg font-light relative z-10" data-id="element-1006">
                  Get in Touch
                </span>
              </div>
            </motion.a>
          </motion.div>
        </div>
      </section>
    </div>;
}